





















































































































































































































import { ICurrentPage } from '~/store/types';
import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State } from 'vuex-class';
import getActiveNodeCount from '~/queries/activeNodes.gql';

@Component
export default class MyNodes extends Vue {
  @State(shareState => shareState.nodesOwned, { namespace: 'share' })
  nodesOwned!: number;
  @State(shareState => shareState.founderNodesOwned, { namespace: 'share' })
  readonly founderNodesOwned!: number;
  @State(shareState => shareState.townstarNodesOwned, { namespace: 'share' })
  readonly townstarNodesOwned!: number;
  @State(shareState => shareState.spiderTanksNodesOwned, { namespace: 'share' })
  readonly spiderTanksNodesOwned!: number;

  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  townstarImg = require(`@/assets/townstar_inventory.png`);

  activeFoundersNodeCount = 0;
  activeTownstarNodeCount = 0;
  activeSpiderTanksNodeCount = 0;

  nodeOsVersions: any[] = [];
  isFetching = false;
  hideOnlineNodeCount = false;

  get activeFoundersNodeCountDisplayed() {
    return Math.min(this.founderNodesOwned, this.activeFoundersNodeCount);
  }

  get activeTownstarNodeCountDisplayed() {
    return Math.min(this.townstarNodesOwned, this.activeTownstarNodeCount);
  }

  get activeSpiderTanksNodeCountDisplayed() {
    return Math.min(
      this.spiderTanksNodesOwned,
      this.activeSpiderTanksNodeCount,
    );
  }

  async created() {
    this.nodeOsVersions = [
      {
        platform: 'mac',
        platformTitle: 'Mac',
        osVersion: this.$t('components.settings.myNodes.osVersionMac'),
        downloadLink: process.env.macDownloadUrl,
        clickToDownload: true,
      },
      {
        platform: 'win',
        platformTitle: 'Windows',
        osVersion: this.$t('components.settings.myNodes.osVersionWindows'),
        downloadLink: process.env.winDownloadUrl,
        clickToDownload: true,
      },
      {
        platform: 'linux',
        platformTitle: 'Ubuntu (Headless)',
        osVersion: this.$t('components.settings.myNodes.osVersionUbuntu'),
        downloadLink: process.env.linuxDownloadUrl,
        clickToDownload: false,
      },
    ];
    this.updateCurrentPage({
      title: 'My Nodes',
      backIcon: 'arrow_back_ios',
      backRoute: `/`,
    });

    try {
      const apolloClient = this.$apolloProvider.clients.gateway;
      this.isFetching = true;
      const { data } = await apolloClient.query({
        query: getActiveNodeCount,
        fetchPolicy: 'no-cache',
      });

      this.isFetching = false;
      this.activeFoundersNodeCount = data.activeNodeCount.founder;
      this.activeTownstarNodeCount = data.activeNodeCount.townstar;
      this.activeSpiderTanksNodeCount =
        data.activeNodeCount.all.find((w: any) => w.workload === 'spidertanks')
          ?.count ?? 0;
    } catch (error) {
      this.$sentry.captureException(error);
      this.hideOnlineNodeCount = true;
    }
  }

  get clientPlatform() {
    const platform = navigator.platform.toLowerCase();

    if (platform.includes('mac')) {
      return 'mac';
    }

    if (platform.includes('win')) {
      return 'win';
    }

    if (platform.includes('linux')) {
      return 'linux';
    }
    return '';
  }

  get groupedPlatformVersions() {
    return this.nodeOsVersions.reduce(
      (acc: { client: any; other: any[] }, cur) => {
        if (cur.platform === this.clientPlatform) {
          acc.client = cur;
        } else {
          acc.other.push(cur);
        }
        return acc;
      },
      { client: null, other: [] },
    );
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
